import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { EstatusJSON } from "../../models/EstatusJSON";
import { IApiBase } from "./Interface/IApiBase.interface";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { CategoryFiltersDTO } from "../../models/CategoryFilters/CategoryFilters";

@Injectable({
  providedIn: "root",
})
export class LayerAPIService implements IApiBase{
  configUrl: string;

  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }
  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }

  GetListLayers(idLayerSource) {
    return this.http.get<EstatusJSON>(
      this.configUrl +
        "/api/Layers/GetListLayers?includeInactives=false&idLayerSource=" +
        idLayerSource,
      {}
    );
  }

  GetLayerDataByNameGeoJSON(name, atributeDisplay = "") {
    return this.http.get<EstatusJSON>(
      this.configUrl +
        "/api/Layers/GetLayerDataByNameGeoJSON?Name=" +
        name +
        "&&ColumnsNamesConcat=" +
        atributeDisplay
    );
  }

  GetLayerDataFilteredByNameGeojson(LayerName: string, FilterValue: string) {
    const filterObject = { LayerName: LayerName, FilterValue: FilterValue };
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/Layers/GetLayerDataFilteredByParamGeoJSON", filterObject
    );
  }

  GetLayersByIdMap(idMap: string) {
    return this.http.get<EstatusJSON>(
      this.configUrl +  "/api/Layers/GetLayersByIdMap?idMap=" + idMap, {}
    );
  }

  // Se quitó, revisar
  GetLayerGPSGeoJson(){
    if(!environment.production) console.log("/api/Location/GetLayerGPSGeoJson/");
      return this.http.get<EstatusJSON>( this.configUrl + "/api/Layers/GetLayerGPSGeoJson", {} );
  }

  GetLayerByIdLocationCategoryGeoJSON( IdLocationCategory : number, filtersApplied: CategoryFiltersDTO[], isForceReload: boolean = false ){
    const body = { Filters: filtersApplied?.map(filter => ({Key: filter.Key, Value: filter.Value})), IdLocationCategory: IdLocationCategory, IsForceReload: isForceReload };
    if(!environment.production) console.log(this.configUrl + "/api/Layers/GetLayerByIdLocationCategoryFilteredGeoJSON");
      return this.http.post<EstatusJSON>(this.configUrl + "/api/Layers/GetLayerByIdLocationCategoryFilteredGeoJSON", body);
      
    // if(!environment.production) console.log(this.configUrl + "/api/Layers/GetLayerByIdLocationCategoryGeoJSON");
    // return this.http.post<EstatusJSON>(this.configUrl + "/api/Layers/GetLayerByIdLocationCategoryGeoJSON", body);
  
  
    // if(!environment.production) console.log(this.configUrl + "/api/LocationCategory/GetLayerByIdLocationCategoryGeoJSON");
    // return this.http.get<EstatusJSON>(this.configUrl + "/api/Location/GetLayerByIdLocationCategoryGeoJSON?IdLocationCategory="+IdLocationCategory)
  }
}
